/**
 * This page's websocket, named in each request to Core (X-Socket-ID): what a request changes is
 * told to every other page, not back to the one that made it (D-206) — it knows already.
 */
let current = () => null
export function setSocket(fn) {
  current = fn || (() => null)
}
/** The headers of a request, with this page's socket when it has one. */
export function withSocket(headers) {
  const id = current()
  if (!id) return headers
  if (headers instanceof Headers) {
    headers.set('X-Socket-ID', id)
    return headers
  }
  return { ...(headers || {}), 'X-Socket-ID': id }
}
